// Normalize OAuth provider avatar URLs to request an appropriately-sized
// image. Google and GitHub serve full-resolution avatars by default, which
// wastes bandwidth and produces blurry results in tiny <img> elements.
// Pass roughly 2x the rendered pixel size for crisp HiDPI displays.
export function getAvatarUrl(url, size = 44) {
	if (!url) return '';

	// Google: ...=s96-c -> ...=s{size}-c
	if (url.includes('googleusercontent.com')) {
		return url.replace(/=s\d+-c$/, `=s${size}-c`);
	}

	// GitHub: append ?s={size} (or &s={size})
	if (url.includes('githubusercontent.com')) {
		const separator = url.includes('?') ? '&' : '?';
		return `${url}${separator}s=${size}`;
	}

	return url;
}

export default getAvatarUrl;
